'use client';

import classNames from 'classnames';
import React, { useEffect, useState, useRef } from 'react';
import { PHONE, EMAIL, DEFAULT_COUNTRY_CODE } from '@/constants';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import {
  setCurrentPage,
  reset,
  setTimer,
  setIsOpenContactUpdate,
  setBackButton,
  setContactUpdateMessage,
} from '@/redux/reducers/my-profile-reducer';
import { getUser, updateUser } from '@/redux/thunk/auth-thunk';
import Icon from '../Icon';
import MyProfileInput from '../MyProfile/MyProfileInput';
import OTP from '../MyProfile/OTP';

function AddEmailPhoneModal({ onView, onClose }) {
  const modalRef = useRef(null);
  const [activeTab, setActiveTab] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();

  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const { currentPage, timer, isOtpVerified, isOpenContactUpdate } =
    useSelector((state) => state.myProfile);

  useEffect(() => {
    if (isOtpVerified) {
      // update email and phone
      if (email.length) {
        dispatch(updateUser({ ...user?.details, email }));
        onClose(false);
        dispatch(
          setContactUpdateMessage(
            'Your email address has been updated successfully',
          ),
        );
      } else if (phone.length) {
        dispatch(
          updateUser({
            ...user?.details,
            phone: `${DEFAULT_COUNTRY_CODE}${phone}`,
          }),
        );
        onClose(false);
        dispatch(
          setContactUpdateMessage(
            'Your phone number has been updated successfully',
          ),
        );
      }
    }
  }, [isOtpVerified]);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        dispatch(reset());
        dispatch(setIsOpenContactUpdate(true));
        document.body.style.overflow = 'hidden';
      }, 100);
    } else {
      dispatch(setIsOpenContactUpdate(false));
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [onView]);

  useEffect(() => {
    const resendTimerInterval = setInterval(() => {
      if (timer > 0) dispatch(setTimer(timer - 1));
      else clearInterval(resendTimerInterval);
    }, 1000);

    return () => clearInterval(resendTimerInterval);
  }, [timer, setTimer]);

  useEffect(() => {
    (async () => {
      if (isLoggedIn && (user === null || user === undefined)) {
        await dispatch(getUser());
      }
    })();
  }, [isLoggedIn, user]);

  const handleUserInput = (data) => {
    if (activeTab === PHONE) {
      setPhone(data);
    } else {
      setEmail(data);
    }
  };

  // set the tab that need to update
  // (if verified by email then can update phone and vice versa)
  useEffect(() => {
    if (user !== null || user !== undefined) {
      if (user?.email?.length) {
        setActiveTab(PHONE);
      } else if (user?.phone?.length) {
        setActiveTab(EMAIL);
      }
    }
  }, [user]);

  const handleClose = () => {
    setTimeout(() => {
      dispatch(setBackButton());
      onClose(false);
    }, 1);
  };

  const handleBackButton = () => {
    if (currentPage === 'otp') {
      dispatch(setCurrentPage('form'));
    } else if (currentPage === 'form') {
      dispatch(setCurrentPage('home'));
      // router.back();
      onClose(false);
    }
  };

  const renderInputTab = () => (
    <MyProfileInput
      activeTab={activeTab}
      userInfo={activeTab === PHONE ? phone : email}
      onUserInput={handleUserInput}
    />
  );

  const renderOTPTab = () => (
    <OTP
      activeTab={activeTab}
      userInfo={activeTab === PHONE ? phone : email}
      setActiveTab={setActiveTab}
    />
  );

  const handleSuccessLogin = () => {
    handleClose();
    dispatch(setIsOpenContactUpdate(false));
    dispatch(setCurrentPage('home'));
  };

  const renderTab = () => {
    switch (currentPage) {
      case 'form':
        return renderInputTab();
      case 'otp':
        return renderOTPTab();
      case 'successUpdate':
        return handleSuccessLogin();
      default:
        return handleClose();
    }
  };

  if (!isOpenContactUpdate) return null;
  return (
    <div
      className={cn(
        'modal w-full h-full bg-white lg:bg-black/30 absolute lg:fixed inset-0 opacity-50 z-[700] invisible lg:flex justify-center items-center overflow-y-hidden lg:overflow-y-auto transition-all duration-300',
        isOpenContactUpdate && '!opacity-100 !visible',
      )}
    >
      <div
        ref={modalRef}
        className={classNames(
          `modal-wrapper w-full h-full lg:!max-w-[480px] lg:!max-h-[284px] lg:px-0 sm:px-0 lg:py-10 sm:py-0 relative lg:rounded-[4px] sm:rounded-[0] transition-all duration-[400ms]`,
        )}
      >
        {/* For Mobile view only */}
        {/* <TopHeaderTitle
          onBack={handleBackButton}
          title="My Profile"
          iconName="angle-down"
        /> */}
        <div className="hidden lg:block mb-16">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose()}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="hidden lg:block">
          {currentPage !== 'successUpdate' ? renderTab() : null}
        </div>
        <div className="block lg:hidden h-full">
          {currentPage !== 'successUpdate' ? renderTab() : null}
        </div>
      </div>
    </div>
  );
}

export default AddEmailPhoneModal;
